import { useCallback, useEffect, useRef } from "react";
import { usePostHog } from "posthog-js/react";

interface UseDebouncedPostHogCaptureOptions {
  delay?: number;
}

export function useDebouncedPostHogCapture(
  options: UseDebouncedPostHogCaptureOptions = {}
) {
  const { delay = 300 } = options;
  const posthog = usePostHog();
  const debounceTimeout = useRef<NodeJS.Timeout | null>(null);

  const captureDebounced = useCallback(
    (
      eventName: string,
      properties?: Record<string, string | number | boolean>
    ) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        posthog.capture(eventName, properties);
      }, delay);
    },
    [posthog, delay]
  );

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, []);

  return captureDebounced;
}
